import { NavLink, Outlet } from 'react-router-dom';
import { TypoCallout, TypoHeading2 } from '@/components/Typography.tsx';

import { useLadderLiveUpdates, useLadderProfile } from './common.ts';

const TABS = [
  { title: 'Overview', to: '/ladder', end: true },
  { title: 'Ladder Rankings', to: '/ladder/rankings' },
  { title: 'Tournament Center', to: '/ladder/tournaments' },
  { title: 'H2H History', to: '/ladder/head-to-head' },
  { title: 'Solo Matches', to: '/ladder/solo' },
  { title: 'Question Vault', to: '/ladder/vault' },
];

const LadderLayout = () => {
  useLadderLiveUpdates();
  const { stats } = useLadderProfile();

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 px-10 pt-6 pb-4 m:px-0">
        <TypoHeading2 className="text-neutral-text-strong font-medium m:text-heading2-m">
          SATPrac Ladder
        </TypoHeading2>
        {stats && (
          <TypoCallout className="px-3 py-1 rounded-full bg-neutral2 text-neutral2-text-soft font-medium">
            Your rank:{' '}
            <strong className="text-neutral2-text-strong">{stats.rank ? `#${stats.rank}` : 'Unranked'}</strong>
          </TypoCallout>
        )}
      </div>
      <nav className="flex gap-x-2 py-1.5 mb-4 overflow-x-auto">
        {TABS.map(({ title, to, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => `px-4 py-1.5 rounded-md font-medium text-callout whitespace-nowrap
              m:min-h-11 m:flex m:items-center
              ${isActive
            ? 'bg-neutral-canvas2 text-neutral-canvas2-text'
            : 'text-neutral-text hover:bg-neutral-canvas2-hover hover:text-neutral-canvas2-hover-text'}`}
          >
            {title}
          </NavLink>
        ))}
      </nav>
      <div className="@container">
        <Outlet />
      </div>
    </>
  );
};

export default LadderLayout;
